import { FormModel } from "ant-design-vue";
const { Item,...other } = FormModel;
import "./formModel.less"
const YwFormModel = {
	...other,
	name: "YwFormModel",
	Item: {
		...Item,
		name: "YwFormModelItem",
	},
};

YwFormModel.install = function (Vue) {
	Vue.component(YwFormModel.name, FormModel);
	Vue.component(YwFormModel.Item.name, FormModel.Item);
};

export default YwFormModel;
